
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.82 1.18a1.16 1.16 0 10-1.64 1.64l1.64-1.64zm11.36 14.64a1.16 1.16 0 101.64-1.64l-1.64 1.64zm1.64-13a1.16 1.16 0 10-1.64-1.64l1.64 1.64zM1.18 14.18a1.16 1.16 0 101.64 1.64l-1.64-1.64zm0-11.36l13 13 1.64-1.64-13-13-1.64 1.64zm13-1.64l-13 13 1.64 1.64 13-13-1.64-1.64z","fill":"currentColor"}})])
          )
        }
      }
    